import { render } from "./VevoDetail.vue?vue&type=template&id=6dbcc598&scoped=true&ts=true"
import script from "./VevoDetail.vue?vue&type=script&lang=ts"
export * from "./VevoDetail.vue?vue&type=script&lang=ts"

import "./VevoDetail.vue?vue&type=style&index=0&id=6dbcc598&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dbcc598"]])

export default __exports__